import React, { useState, useEffect } from "react";
import HeadRegresar from "../../sharecomponents/HeadRegresar";
import axios from "axios";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import { API_URL } from "../../../utils/Common";

const ImagenFlor = (props) => {
   // -- para la imagen
   const [selectedFile, updateSelectedFile] = useState(null);

   const handleFileChange = (e) => {
      if (e.target.files[0] !== undefined) {
         updateSelectedFile({
            file: e.target.files[0],
            urlFile: URL.createObjectURL(e.target.files[0]),
         });
      } else {
         updateSelectedFile(null);
      }
   };

   const onSubmit = (e) => {
      e.preventDefault();
      console.log(selectedFile);
      const data = new FormData();
      data.append("file", selectedFile.file);
      data.append("id", props.match.params.id);

      axios
         .post(API_URL + "/flor/uploadFile", data)
         .then((r) => {
            console.log(r.data);
            updateSelectedFile(null);
            props.history.goBack();
            // ToastsStore.success("Imagen cargada correctamente!");
         })
         .catch((err) => console.log(err));
   };

   useEffect(() => {
      const fileTypes = ["image/jpeg", "image/gif", "image/png", "image/bmp", "image/webp"];

      if (selectedFile != null) {
         if (!fileTypes.includes(selectedFile.file.type)) {
            updateSelectedFile(null);
            ToastsStore.error("Seleccione un archivo de tipo imagen");
         }
      }
   }, [selectedFile, updateSelectedFile]);

   return (
      <div className="w-full p-3">
         <div className="bg-white border rounded shadow">
            <div className="border-b rounded-t p-3 bg-orange-900">
               <HeadRegresar titulo="Alta Imagen de la Flor" history={props.history} />
            </div>
            <div className="p-5 rounded-b">
               <form onSubmit={onSubmit}>
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                     Seleccione una imagen:
                  </label>
                  <input id="file" className="mr-4" type="file" name="file" onChange={handleFileChange} />
                  <button
                     type="submit"
                     className={
                        selectedFile
                           ? "bg-orange-800 hover:bg-orange-700 text-white py-1 px-4 rounded shadow"
                           : "bg-orange-800 text-white font-bold py-1 px-4 rounded opacity-50 cursor-not-allowed"
                     }
                     disabled={!selectedFile}
                  >
                     <li className="fas fa-upload mr-1" />
                     Subir Archivo
                  </button>
               </form>
               <h2 className="mt-5">Imagen Seleccionada:</h2>
               <hr />
               <div className="max-w-lg rounded overflow-hidden shadow-lg mt-5">
                  {selectedFile && <img src={selectedFile.urlFile} alt="archivo seleccionado" />}
               </div>
            </div>
         </div>
         <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
      </div>
   );
};

export default ImagenFlor;
